<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="calificacion" titulo="Calificación / Control Escolar" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div id="banner" align="center" *ngIf="ctrl.cargando || ctrl.cargarDatosCatalogo || cargando">
  <div class="bloquear-azul">

  </div>
  <span class="tag is-primary is-large "
    style="position: absolute; top: 45%; font-size: 2em; z-index: 999999999;  left: 45%;">
    <span class="icon">
      <i class="icon-worldwide fa-spin"></i>
    </span> &nbsp;
    <span>Cargando...</span>
  </span>
</div>

<div class="contenedor columns " style="height:100%; ">
  <div class="column is-2 is-hidden-mobile menu-izquierda">

    <!-- Menu izquierda del modulo enviroment" -->
    <app-sistema-menu-aside></app-sistema-menu-aside>
  </div>
  <div class="column" style="padding:0px;">
    <div style="background: #FFF; border-radius: 1em; height:100%;">

      <!-- formulario -->
      <form name="form" novalidate>
        <section class="hero is-primary">
          <div class="hero-body">

            <!-- Opciones  -->
            <section class="hero is-primary">
              <div class="hero-head">
                <nav class="level">
                  <!-- Left side -->
                  <div class="level-left">
                    <div class="level-item">
                      <p class="title">
                        <span *ngIf="!ctrl.cargando" class="icon is-medium">
                          <i class="icon-computer6"></i>
                        </span>
                        <span *ngIf="ctrl.cargando  || cargando" class="icon is-medium">
                          <i class="icon-worldwide fa-spin"></i>
                        </span>
                        <span class="icon is-medium">
                          <i class="icon-file"></i>
                        </span> Calificaciones
                      </p>
                    </div>

                  </div>

                  <!-- Right side -->
                  <div class="level-right"> 

                    <a class="navbar-item is-primary tooltip" (click)="ctrl.regresar()">
                      <span class="icon fa-2x">
                        <i class="icon-back"> </i>
                      </span>
                      <span class="tooltiptext">Regresar</span>
                    </a>

                    <a class="navbar-item is-primary tooltip" (click)="cargarDatos()">
                      <span class="icon fa-2x has-text-success">
                        <i class="icon-search "></i>
                      </span>
                      <span class="tooltiptext">Buscar Boletas</span>
                    </a>

                    <a class="navbar-item is-primary tooltip" (click)="verDatosHistorial()">   
                      <span class="icon fa-2x has-text-link">
                        <i class="icon-search "></i>
                      </span>
                      <span class="tooltiptext">Buscar Historia y Certificados ></span>
                    </a>
                  </div>
                </nav>
              </div>
            </section>
          </div>
        </section>

        <a id="catalogos"
          (click)="ctrl.cargarCatalogo('periodos_escolares', 'periodo-escolar-catalogo', '', 'cargando_periodo');  ctrl.cargarCatalogo('logos64', 'logos64', 'logo64');"></a>
        <a id="logo64" (click)="asignarLogos(ctrl.logos64); "></a>

        <section class="section" style="overflow-y:auto; overflow-x:hidden; padding: 1rem; height: 86vh;">

          <div class="columns">
            <div class="column is-6">
              <label class="label">Período escolar:</label>
              <div class="control has-icons-left has-icons-right">
                <span class="icon is-small is-left">
                  <i class="icon-worldwide fa-spin" *ngIf="ctrl.cargando_periodo"></i>
                </span>
                <ng-select2
                  [disabled]="activos ? true :ctrl.periodos_escolares ? ctrl.periodos_escolares.length == 0 ? true : false : true"
                  [options]="ctrl.optionSelect"
                  (valueChanged)="seleccionarPeriodo($event); ctrl.grupos = []; $event ? ctrl.catalogoDependiente('grupo-periodo', 'grupos', ($event.hasOwnProperty('value') ? $event.value : $event)) : '';"
                  [data]="ctrl.periodos_escolares"></ng-select2>
              </div>
            </div>

            <div class="column is-6">
              <label class="label">Seleccione el grupo:</label>
              <ng-select2 [disabled]="activos ? true : ctrl.grupos ? ctrl.grupos.length == 0 ? true : false : true"
                [options]="ctrl.optionSelect" (valueChanged)="seleccionarGrupo($event, ctrl.grupos);"
                [data]="ctrl.grupos"></ng-select2>
            </div>
          </div>

          <section class="tile is-ancestor">
            <div class="tile is-vertical is-12">
              <div class="tile">
                <div class="tile">
                  <div class="tile is-parent">
                    <article class=" tile is-child notification">
                      <p class="subtitle">
                        <i class="icon-community "></i> Grupos encontrados
                      </p>
                      <div class="fa has-text-black">

                      </div>

                      <div class="content" style="font-size: 4em;">

                        {{total_grupos}}
                      </div>
                    </article>
                  </div>
                </div>

                <div class="tile">
                  <div class="tile is-parent">
                    <article class=" tile is-child notification">
                      <p class="subtitle">
                        <i class="icon-election "></i> Alumnos encontrados
                      </p>
                      <div class="fa has-text-black">

                      </div>

                      <div class="content" style="font-size: 4em;">

                        {{total_alumnos}}
                      </div>
                    </article>
                  </div>
                </div>
              </div>
              <div class="tile">
                <div class="tile is-parent">
                  <article class=" tile is-child notification">
                    <p class="subtitle">
                      <i class="icon-printer "></i> Imprimir
                    </p>

                    <div class="content" *ngIf="dato.length > 0">
                      <div class="columns">
                        <div class="column is-4" style="height: 100px;">
                          <button class="button is-fullwidth is-fullheight" type="button" (click)="imprimirParcial()"
                            style="height: 100px;">
                            <span class="icon fa-4x has-text-link">
                              <i class="icon-printer"></i>
                            </span>
                            <span class="tooltiptext">Boleta Parcial</span>
                          </button>
                        </div>

                        <div class="column is-4" style="height: 100px;">
                          <button class="button is-fullwidth is-fullheight" type="button"
                            (click)="imprimirBoletaPromedio()" style="height: 100px;">
                            <span class="icon fa-4x has-text-success">
                              <i class="icon-printer"></i>
                            </span>
                            <span class="tooltiptext">Boleta por Nivel</span>
                          </button>
                        </div>

                        <div class="column is-4" style="height: 100px;">
                          <button class="button is-fullwidth is-fullheight" type="button"
                            (click)="ctrl.abrirModal('envioBoletas');" style="height: 100px;">
                            <span class="icon fa-4x has-text-danger">
                              <i class="icon-email2"></i>
                            </span>
                            <span class="tooltiptext">Enviar Boleta</span>
                          </button>
                        </div>
                      </div>

                      <br>

                      <div class="columns">
                        <div class="column is-6" style="height: 100px;">
                          <button class="button is-fullwidth is-fullheight" type="button"
                            (click)="imprimirConcentrado()" style="height: 100px;">
                            <span class="icon fa-4x has-text-black">
                              <i class="icon-printer"></i>
                            </span>
                            <span class="tooltiptext">Concentrado parcial</span>
                          </button>
                        </div>

                        <div class="column is-6" style="height: 100px;">
                          <button class="button is-fullwidth is-fullheight" type="button"
                            (click)="imprimirConcentrado2()" style="height: 100px;">
                            <span class="icon fa-4x has-text-warning">
                              <i class="icon-printer"></i>
                            </span>
                            <span class="tooltiptext">Concentrado por nivel</span>
                          </button>
                        </div>
                      </div>

                    </div>

                    <!-- <div class="content" *ngIf="kardex">  *ngIf="dataHistorial.length > 0" -->

                    <div class="content" *ngIf="dataHistorial.length > 0">
                      <form (ngSubmit)="imprimirCertificadoDos()" [formGroup]="miformulario">
                        <div class="columns is-centered">
                          <div class="column is-half">
                            <button class="button is-fullwidth is-fullheight" type="button"
                              (click)="imprimirHistorialDos()" style="height: 100px;">
                              <span class="icon fa-4x has-text-link">
                                <i class="icon-printer"></i>
                              </span>
                              <span class="tooltiptext">Historial Academico</span>
                            </button>
                          </div>
                        </div>

                        <div class="columns">
                          <div class="column is-full">
                            <article class="panel">
                              <p class="panel-heading">
                                CONFIGURACIÓN DE CERTIFICADO
                              </p>

                              <div class="columns is-desktop">
                                <div class="column">
                                  <article class="panel">
                                    <p class="panel-heading" style="font-size: 18px;">
                                      CONFIGURACIÓN DE INSTITUCIÓN
                                    </p>
                                    <div class="panel-block">
                                      <div class="columns">
                                        <div class="column is-full">
                                          <div class="field">
                                            <label class="label" style="font-size: 20px;">
                                              Representante de la institución
                                            </label>
                                          </div>
                                          <div class="columns">

                                            <div class="column is-6">
                                              <div class="field">
                                                <label class="label">Puesto</label>
                                                <p class="control has-icons-left has-icons-right">
                                                  <!-- <input class="input is-link" type="text"
                                                  [(ngModel)]="certificado.director"
                                                  name="nombre"
                                                  [ngModelOptions]="{standalone: true}"> -->
                                                  <input class="input is-link" type="text"
                                                    formControlName="puesto_dire">
                                                </p>
                                                <!-- <article class="message is-danger" *ngIf="campoEsValido('director')">
                                              <div class="message-body">
                                                 <strong> Este campo es obligatorio </strong>
                                              </div>
                                            </article> -->

                                                <!-- <div class="notification is-danger" *ngIf="campoEsValido('director')">
                                              <button class="delete"></button>
                                              Este campo es obligatorio
                                            </div> -->

                                                <span *ngIf="campoEsValido('puesto_dire')" style="color: red;">
                                                  <strong>Este campo es obligatorio</strong>
                                                </span>
                                              </div>
                                              <!--  <div class="field">
                                              <br>
  
                                              <div class="b-checkbox is-info is-circular">
                                                <input id="director_sexo" name="director_sexo" class="styled" type="radio"
                                                  value="H" [(ngModel)]="certificado.director_sexo"
                                                  [ngModelOptions]="{standalone: true}"
                                                  [checked]="certificado.director_sexo == 'H'">
                                                <label for="director_sexo" class="radio">Hombre &nbsp;</label>
  
                                                <input id="director_sexo2" name="director_sexo2" class="styled"
                                                  type="radio" value="M" [(ngModel)]="certificado.director_sexo"
                                                  [ngModelOptions]="{standalone: true}"
                                                  [checked]="certificado.director_sexo == 'M'">
                                                <label class="radio" for="director_sexo2">Mujer</label>
                                              </div>
                                            </div> -->
                                            </div>

                                            <div class="column is-6">
                                              <div class="field">
                                                <label class="label">Nombre</label>
                                                <p class="control has-icons-left has-icons-right">
                                                  <!-- <input class="input is-link" type="text"
                                                  [(ngModel)]="certificado.director"
                                                  name="nombre"
                                                  [ngModelOptions]="{standalone: true}"> -->
                                                  <input class="input is-link" type="text" formControlName="director">
                                                </p>
                                                <!-- <article class="message is-danger" *ngIf="campoEsValido('director')">
                                              <div class="message-body">
                                                 <strong> Este campo es obligatorio </strong>
                                              </div>
                                            </article> -->

                                                <!-- <div class="notification is-danger" *ngIf="campoEsValido('director')">
                                              <button class="delete"></button>
                                              Este campo es obligatorio
                                            </div> -->

                                                <span *ngIf="campoEsValido('director')" style="color: red;">
                                                  <strong>Este campo es obligatorio</strong>
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <!-- <div class="panel-block" *ngIf="tipo_nivel == 0">
                                      <div class="columns">
                                        <div class="column is-full">
                                          <div class="field">
                                            <label class="label">Responsable de servicios escolares</label>
                                            <p class="control  has-icons-right">
                                              <input class="input is-link" type="text" formControlName="resposableSE">
                                            </p>
                                            <span *ngIf="campoEsValido('resposableSE')" style="color: red;">
                                              <strong>Este campo es obligatorio</strong>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div> -->

                                    <div class="panel-block">
                                      <div class="columns">
                                        <div class="column is-full">
                                          <div class="field">
                                            <label class="label">Servicios Escolares</label>
                                          </div>
                                          <div class="columns">
                                            <div class="column ">
                                              <div class="field">
                                                <label class="label">Puesto</label>
                                                <p class="control  has-icons-right">

                                                  <input class="input is-link" type="text"
                                                    formControlName="responsableP_ServEsc">
                                                </p>

                                                <!-- <span *ngIf="campoEsValido('responsableP_ServEsc')" style="color: red;">
                                                  <strong>Este campo es obligatorio</strong>
                                                </span> -->
                                              </div>
                                            </div>

                                            <div class="column">
                                              <div class="field">
                                                <label class="label">Nombre</label>
                                                <p class="control  has-icons-right">

                                                  <input class="input is-link" type="text"
                                                    formControlName="resposableSE">
                                                </p>

                                                <span *ngIf="campoEsValido('resposableSE')" style="color: red;">
                                                  <strong>Este campo es obligatorio</strong>
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <br>
                                    <br>


                                  </article>
                                </div>
                                <div class="column">
                                  <article class="panel">
                                    <p class="panel-heading" style="font-size: 18px;">
                                      CONFIGURACIÓN DE SECRETARÍA DE EDUCACIÓN
                                    </p>
                                    <div class="panel-block">
                                      <div class="columns">
                                        <div class="column is-full">
                                          <div class="field">
                                            <label class="label">Cotejo</label>
                                            <p class="control  has-icons-right">
                                              <!-- <input class="input is-link" type="text" [(ngModel)]="certificado.cotejo"
                                                [ngModelOptions]="{standalone: true}"> -->

                                              <input class="input is-link" type="text" formControlName="cotejo">
                                            </p>


                                            <span *ngIf="campoEsValido('cotejo')" style="color: red;">
                                              <strong>Este campo es obligatorio</strong>
                                            </span>

                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="panel-block">
                                      <div class="columns">
                                        <div class="column is-full">
                                          <div class="field">
                                            <label class="label" style="font-size: 20px">Oficina</label>
                                          </div>

                                          <div class="columns">
                                            <div class="column">
                                              <div class="field">
                                                <label class="label">Puesto</label>
                                                <p class="control  has-icons-right">
                                                  <!-- <input class="input is-link" type="text"
                                                    [(ngModel)]="certificado.puesto_oficina"
                                                    [ngModelOptions]="{standalone: true}"> -->

                                                  <input class="input is-link" type="text"
                                                    formControlName="puesto_oficina">
                                                </p>
                                                <span *ngIf="campoEsValido('puesto_oficina')" style="color: red;">
                                                  <strong>Este campo es obligatorio</strong>
                                                </span>
                                              </div>
                                            </div>
                                            <div class="column">
                                              <div class="field">
                                                <label class="label">Nombre</label>
                                                <p class="control  has-icons-right">
                                                  <!-- <input class="input is-link" type="text"
                                                    [(ngModel)]="certificado.nombre_oficina"
                                                    [ngModelOptions]="{standalone: true}"> -->
                                                  <input class="input is-link" type="text"
                                                    formControlName="nombre_oficina">
                                                </p>

                                                <span *ngIf="campoEsValido('nombre_oficina')" style="color: red;">
                                                  <strong>Este campo es obligatorio</strong>
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="panel-block">
                                      <div class="columns">
                                        <div class="column is-full">
                                          <div class="field">
                                            <label class="label">Servicios Escolares</label>
                                            <!-- <label class="label">Jef{{certificado.jefe_ServEsc_sexo == 'H' ? 'e' : 'a'}}
                                                del departamento de servicios escolares</label> -->
                                            <!-- <p class="control has-icons-left has-icons-right">
                                                <input class="input is-link" type="text"
                                                  [(ngModel)]="certificado.jefe_ServEsc"
                                                  [ngModelOptions]="{standalone: true}">
                                              </p> -->
                                          </div>
                                          <div class="columns">
                                            <div class="column">
                                              <div class="field">
                                                <label class="label">Puesto</label>
                                                <p class="control  has-icons-right">
                                                  <!-- <input class="input is-link" type="text"
                                                    [(ngModel)]="certificado.puesto_ServEsc"
                                                    [ngModelOptions]="{standalone: true}"> -->
                                                  <input class="input is-link" type="text"
                                                    formControlName="puesto_ServEsc">
                                                </p>

                                                <span *ngIf="campoEsValido('puesto_ServEsc')" style="color: red;">
                                                  <strong>Este campo es obligatorio</strong>
                                                </span>
                                              </div>
                                            </div>

                                            <div class="column">
                                              <div class="field">
                                                <label class="label">Nombre</label>
                                                <p class="control  has-icons-right">
                                                  <!-- <input class="input is-link" type="text"
                                                    [(ngModel)]="certificado.jefe_ServEsc"
                                                    [ngModelOptions]="{standalone: true}"> -->
                                                  <input class="input is-link" type="text"
                                                    formControlName="jefe_ServEsc">
                                                </p>

                                                <span *ngIf="campoEsValido('jefe_ServEsc')" style="color: red;">
                                                  <strong>Este campo es obligatorio</strong>
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <!-- <div class="column is-4">
                                            <div class="field">
                                              <br>
                                              <br>
                                              <br>
                                              <div class="b-checkbox is-info is-circular">
                                                <input id="jefe_ServEsc_sexo" name="jefe_ServEsc_sexo" class="styled"
                                                  type="radio" value="H" [(ngModel)]="certificado.jefe_ServEsc_sexo"
                                                  [ngModelOptions]="{standalone: true}"
                                                  [checked]="certificado.jefe_ServEsc_sexo == 'H'">
                                                <label for="jefe_ServEsc_sexo" class="radio">Hombre &nbsp;</label>
    
                                                <input id="jefe_ServEsc_sexo2" name="jefe_ServEsc_sex2o" class="styled"
                                                  type="radio" value="M" [(ngModel)]="certificado.jefe_ServEsc_sexo"
                                                  [ngModelOptions]="{standalone: true}"
                                                  [checked]="certificado.jefe_ServEsc_sexo == 'M'">
                                                <label class="radio" for="jefe_ServEsc_sexo2">Mujer</label>
                                              </div>
                                            </div>
                                          </div> -->
                                      </div>
                                    </div>
                                  </article>
                                </div>
                                <div class="column">
                                  <article class="panel">
                                    <p class="panel-heading" style="font-size: 18px;">
                                      CONFIGURACIÓN DE GOBIERNO
                                    </p>
                                    <div class="panel-block">
                                      <div class="columns">
                                        <div class="column is-full">
                                          <div class="field">
                                            <!-- <label class="label">Director{{certificado.directorEs_sexo == 'H' ? '' : 'a'}}
                                                de educación superior</label> -->

                                            <label class="label">Educación Superior</label>
                                            <!-- <p class="control has-icons-left has-icons-right">
                                                <input class="input is-link" type="text"
                                                  [(ngModel)]="certificado.directorES"
                                                  [ngModelOptions]="{standalone: true}">
                                              </p> -->
                                          </div>

                                          <div class="columns">
                                            <div class="column">
                                              <div class="field">
                                                <label class="label">Puesto</label>
                                                <p class="control  has-icons-right">
                                                  <!-- <input class="input is-link" type="text"
                                                    [(ngModel)]="certificado.puesto_Es"
                                                    [ngModelOptions]="{standalone: true}"> -->

                                                  <input class="input is-link" type="text" formControlName="puesto_ES">
                                                </p>

                                                <span *ngIf="campoEsValido('puesto_ES')" style="color: red;">
                                                  <strong>Este campo es obligatorio</strong>
                                                </span>
                                              </div>
                                            </div>

                                            <div class="column">
                                              <div class="field">
                                                <label class="label">Nombre</label>
                                                <p class="control  has-icons-right">
                                                  <!-- <input class="input is-link" type="text"
                                                    [(ngModel)]="certificado.directorES"
                                                    [ngModelOptions]="{standalone: true}"> -->

                                                  <input class="input is-link" type="text" formControlName="directorES">
                                                </p>

                                                <span *ngIf="campoEsValido('directorES')" style="color: red;">
                                                  <strong>Este campo es obligatorio</strong>
                                                </span>

                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <!-- <div class="column is-3">
                                            <div class="field">
                                              <br>
                                              
                                             <div class="b-checkbox is-info is-circular">
                                                <input id="directorEs_sexo" name="directorEs_sexo" class="styled"
                                                  type="radio" value="H" [(ngModel)]="certificado.directorEs_sexo"
                                                  [ngModelOptions]="{standalone: true}"
                                                  [checked]="certificado.directorEs_sexo == 'H'">
                                                <label for="directorEs_sexo" class="radio">Hombre &nbsp;</label>
    
                                                <input id="directorEs_sexo2" name="directorEs_sexo2" class="styled"
                                                  type="radio" value="M" [(ngModel)]="certificado.directorEs_sexo"
                                                  [ngModelOptions]="{standalone: true}"
                                                  [checked]="certificado.directorEs_sexo == 'M'">
                                                <label class="radio" for="directorEs_sexo2">Mujer</label>
                                              </div>
                                            </div>
                                          </div> -->
                                      </div>
                                    </div>

                                    <div class="panel-block">
                                      <div class="columns">
                                        <div class="column is-full">
                                          <div class="field">
                                            <label class="label" style="font-size: 20px">*</label>
                                          </div>

                                          <div class="columns">
                                            <div class="column">
                                              <div class="field">
                                                <label class="label">Puesto</label>
                                                <p class="control  has-icons-right">
                                                  <!-- <input class="input is-link" type="text"
                                                    [(ngModel)]="certificado.puesto_asuntos_juridicos"
                                                    [ngModelOptions]="{standalone: true}"> -->

                                                  <input class="input is-link" type="text"
                                                    formControlName="puesto_asuntos_juridicos">
                                                </p>

                                                <span *ngIf="campoEsValido('puesto_asuntos_juridicos')"
                                                  style="color: red;">
                                                  <strong>Este campo es obligatorio</strong>
                                                </span>

                                              </div>
                                            </div>
                                            <div class="column">
                                              <div class="field">
                                                <label class="label">Nombre</label>
                                                <p class="control  has-icons-right">
                                                  <!-- <input class="input is-link" type="text"
                                                    [(ngModel)]="certificado.nombre_asuntos_juridicos"
                                                    [ngModelOptions]="{standalone: true}"> -->
                                                  <input class="input is-link" type="text"
                                                    formControlName="nombre_asuntos_juridicos">
                                                </p>

                                                <span *ngIf="campoEsValido('nombre_asuntos_juridicos')"
                                                  style="color: red;">
                                                  <strong>Este campo es obligatorio</strong>
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </article>
                                </div>
                              </div>

                              <!-- <div class="columns is-desktop">
                                <div class="column is-full">
                                  <article class="panel">
                                    <p class="panel-heading">
                                      CONFIGURACIÓN DE FUNDAMENTO DE LEGALIDAD
                                    </p>
                                    <div class="columns">
                                      <div class="column">
                                        <textarea class="textarea" placeholder="POR ACUERDO..."
                                          formControlName="acuerdo" name="acuerdo" rows="12"></textarea>
                                      </div>
                                    </div>
                                  </article>
                                </div>
                              </div> -->

                              <div class="columns is-desktop" *ngIf="tipo_nivel != 0">
                                <div class="column is-full">
                                  <article class="panel">
                                    <p class="panel-heading">
                                      CONFIGURACIÓN DE ESCALA DE CALIFICACIONES PARA POSGRADOS
                                    </p>

                                    <div class="columns">
                                      <div class="column">
                                        <!--   <textarea class="textarea" placeholder="POR ACUERDO..."
                                          [(ngModel)]="certificado.acuerdo_texto"
                                          [ngModelOptions]="{standalone: true}"></textarea> -->
                                        <textarea class="textarea"
                                          placeholder="LA ESCALA DE CALIFICACIONES ES DE 5 A 10, CONSIDERANDO COMO MÍNIMO APROBATORIO 8 (OCHO), ESTE CERTIFICADO AMPARA DICEISÉIS MATERIAS DEL PLAN DE ESTUDIOS VIGENTE Y EN CUMPLIMIENTO A LAS PRESCRIPCIONES LEGALES, SE EXPIDE EN LA CIUDAD DE TUXTLA GUTIÉRREZ, CHIAPAS A LOS..."
                                          formControlName="escala" name="escala" rows="12"></textarea>

                                        <br>
                                        <span *ngIf="campoEsValido('escala')" style="color: red;">
                                          <strong>Este campo es obligatorio</strong>
                                        </span>

                                      </div>


                                    </div>
                                  </article>
                                </div>

                              </div>

                              <div class="columns is-desktop">
                                <div class="column">
                                  <article class="panel">
                                    <p class="panel-heading">
                                      CONFIGURACIÓN DE FOLIO
                                    </p>
                                    <div class="panel-block">
                                      <div class="columns">
                                        <div class="column">
                                          <div class="field">
                                            <label class="label">Número</label>
                                            <p class="control  has-icons-right">
                                              <input class="input is-link" type="text" [(ngModel)]="numeroAzar"
                                                [ngModelOptions]="{standalone: true}">
                                            </p>
                                          </div>
                                        </div>
                                        <!-- <div class="column">
                                            <div class="field">
                                              <label class="label">Folio L</label>
                                              <p class="control  has-icons-right">
                                                <input class="input is-link" type="text"
                                                  [(ngModel)]="folioLetra"
                                                  [ngModelOptions]="{standalone: true}">
                                              </p>
                                            </div>
                                          </div> -->

                                        <!-- <div class="column">
                                            <div class="field">
                                              <label class="label">Folio N</label>
                                              <p class="control  has-icons-right">
                                                <input class="input is-link" type="text"
                                                  [(ngModel)]="folioNumero"
                                                  [ngModelOptions]="{standalone: true}">
                                              </p>
                                            </div>
                                          </div>
    
                                          <div class="column">
                                            <div class="field">
                                              <label class="label">Folio T</label>
                                              <p class="control  has-icons-right">
                                                <input class="input is-link" type="text"
                                                  [(ngModel)]="folioLongitud"
                                                  [ngModelOptions]="{standalone: true}">
                                              </p>
                                            </div>
                                          </div> -->
                                      </div>
                                    </div>
                                    <!-- <div class="panel-block">
                                        <div class="columns">
                                          <div class="column">
                                            <div class="field">
                                              <label class="label">Número</label>
                                              <p class="control  has-icons-right">
                                                <input class="input is-link" type="text"
                                                  [(ngModel)]="numeroAzar"
                                                  [ngModelOptions]="{standalone: true}">
                                              </p>
                                            </div>
                                          </div>
                                          <div class="column">
                                            <div class="field">
                                              <label class="label">Folio L</label>
                                              <p class="control  has-icons-right">
                                                <input class="input is-link" type="text"
                                                  [(ngModel)]="folioLetra"
                                                  [ngModelOptions]="{standalone: true}">
                                              </p>
                                            </div>
                                          </div> 
    
                                          <div class="column">
                                            <div class="field">
                                              <label class="label">Folio N</label>
                                              <p class="control  has-icons-right">
                                                <input class="input is-link" type="text"
                                                  [(ngModel)]="folioNumero"
                                                  [ngModelOptions]="{standalone: true}">
                                              </p>
                                            </div>
                                          </div>
    
                                          <div class="column">
                                            <div class="field">
                                              <label class="label">Folio T</label>
                                              <p class="control  has-icons-right">
                                                <input class="input is-link" type="text"
                                                  [(ngModel)]="folioLongitud"
                                                  [ngModelOptions]="{standalone: true}">
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>-->
                                  </article>
                                </div>
                                <div class="column">
                                  <article class="panel">
                                    <p class="panel-heading">
                                      CONFIGURACIÓN FECHA
                                    </p>
                                    <div class="panel-block">
                                      <div class="field">
                                        <div class=" is-info">
                                          <label class="label">Fecha:</label>
                                          <p class="control has-icons-left has-icons-right">
                                            <!-- <input class="input" type="date" [(ngModel)]="certificado.fecha"
                                              [ngModelOptions]="{standalone: true}" required> -->
                                            <input class="input" type="date" formControlName="fecha" name="fecha">
                                          </p>
                                          <span *ngIf="campoEsValido('fecha')" style="color: red;">
                                            <strong>Este campo es obligatorio</strong>
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <br>
                                  </article>
                                </div>
                                <div class="column">
                                  <article class="panel">
                                    <br>
                                    <br>
                                    <br>
                                    <div class="panel-block">
                                      <button class="button is-fullwidth is-fullheight" type="submit"
                                        style="height: 100px;" [disabled]="miformulario.invalid">
                                        <span class="icon fa-4x has-text-success">
                                          <i class="icon-printer"></i>
                                        </span>
                                        <span class="tooltiptext">CERTIFICADO</span>
                                      </button>
                                    </div>
                                  </article>
                                </div>
                              </div>
                            </article>
                          </div>
                        </div>
                      </form>
                    </div>


                  </article>
                </div>
              </div>

            </div>
          </section>
        </section>
      </form>
    </div>
  </div>
</div>

<div class="modal" id="envioBoletas">
  <div class="modal-background"></div>
  <div *ngIf="dato_email!=''" class="modal-card" style="width: 96vw;height: 96vh;">
    <header class="modal-card-head">
      <p class="modal-card-title">
        <span class="icon">
          <i class="icon-email2"></i>
        </span> Envio de Boletas
      </p>
      <button type="button" class="delete" (click)="ctrl.cancelarModal('envioBoletas');"></button>
    </header>
    <section class="modal-card-body">
      <nav class="level is-mobile">
        <div class="level-item has-text-centered">
          <div>
            <p class="heading">Periodo</p>
            <p class="title">{{dato_email.periodos_escolares.nombre}}</p>
          </div>
        </div>
        <div class="level-item has-text-centered">
          <div>
            <p class="heading">Carrera</p>
            <p class="title">{{dato_email.carrera_plan.carreras.nombre}}</p>
          </div>
        </div>
        <div class="level-item has-text-centered">
          <div>
            <p class="heading">Grupo</p>
            <p class="title">{{dato_email.grupo.clave}}</p>
          </div>
        </div>
      </nav>

      <div class="card">
        <div class="card-content">

          <div class="content">
            <div class="select is-info is-medium">
              <select class="select" [(ngModel)]="tipo_boleta">
                <option [value]="1">Boleta Parcial</option>
                <option [value]="2">Boleta Final</option>
              </select>
            </div>
          </div>
          <div class="table-container" [formGroup]="data">
            <table class="table is-bordered is-striped" style="width:100% !important;">
              <thead>
                <tr style="text-align: center;">
                  <th>Alumno</th>
                  <th>Enviar boleta</th>
                </tr>
              </thead>
              <tbody formArrayName="alumnos">
                <tr *ngFor="let alumno of data.controls.alumnos.controls;let i = index;" [formGroupName]="i">
                  <td style="vertical-align: middle;">{{alumno.value.nombre}}</td>
                  <td style="text-align: center;">
                    <label class="checkbox">
                      <input type="checkbox" [value]="1" style="transform: scale(2);" formControlName="enviar">
                    </label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

    </section>
    <footer class="modal-card-foot">
      <a class="button is-success" (click)="ctrl.cancelarModal('envioBoletas');">Cerrar</a>
      <a class="button is-warning" (click)="enviarBoletas(enviar)"><span class="icon"> <i
            class="icon-email2"></i></span> <span>Enviar Boletas</span> </a>
      <!-- <a class="button is-link" (click)="imprimirKardexdos();"> <span class="icon"> <i
                        class="fa fa-print"></i></span> <span>Kardex</span> </a>
            <a class="button is-warning" (click)="imprimirHistorial();"> <span class="icon"> <i
                        class="fa fa-print"></i></span> <span>Historial Académico</span> </a> -->
    </footer>
  </div>
</div>